// extracted by mini-css-extract-plugin
export default {"addNewMember":"AddMemberToClass_addNewMember__w++PD","addNewMemberLink":"AddMemberToClass_addNewMemberLink__dxOZO"};